import { parse } from 'query-string'

export const urlParamsParser = (url: string) => parse(url)



// WEBPACK FOOTER //
// ./src/infrastructure/utils/urlParamsParser.ts